import axios, {AxiosResponse} from "axios";

export const HttpService = {
    async get<T>(url: string): Promise<HttpResponse<T>> {
        try {
            const response: AxiosResponse<any> = await axios.get(url);

            return {
                status: true,
                data: response.data
            };
        } catch (error: any) {
            return { status: false, data: error };
        }
    },
    async post<T>(url: string, data: any): Promise<HttpResponse<T>> {
        try {
            const response: AxiosResponse<any> = await axios.post(url, data);
            return {
                status: true,
                data: response.data
            };
        } catch (error: any) {
            return { status: false, data: error };
        }
    },
    async put<T>(url: string, data: any): Promise<HttpResponse<T>> {
        try {
            const response: AxiosResponse<any> = await axios.put(url, data);
            return {
                status: true,
                data: response.data
            };
        } catch (error: any) {
            return { status: false, data: error };
        }
    },
    async delete(url: string) {

    },
    async patch<T>(url: string, data: any): Promise<HttpResponse<T>> {
        try {
            const response: AxiosResponse<any> = await axios.patch(url, data);

            return {
                status: true,
                data: response.data
            };
        } catch (error: any) {
            return { status: false, data: error };
        }
    }
}

export interface HttpResponse<T> {
    status: boolean;
    data: T;
}
